<template>
  <div class="fling-center">
    <navbar :title="title" left-text show-home />
    <div class="recharge-kinds">
      <div class="hot-column" v-show="recColumnList.length">
        <div class="title">娱乐充值</div>
        <hot-column-list :column-list="recColumnList" />
      </div>
      <div class="hot-column" v-show="readColumnList.length">
        <div class="title">阅读时光</div>
        <hot-column-list :column-list="readColumnList" />
      </div>
      <div class="hot-column" v-show="videoColumnList.length">
        <div class="title">影音卡券</div>
        <hot-column-list :column-list="videoColumnList" />
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
import HotColumnList from '../components/flingCenter/HotColumnList'
import api from '../utils/api'
import { mapState } from 'vuex'
export default {
  name: 'flingCenter',
  components: {
    Navbar,
    HotColumnList
  },
  data () {
    return {
      recColumnList: [],
      readColumnList: [],
      videoColumnList: [],
      hotRechargeColumnNav: [],
      pageNum: 1
    }
  },
  computed: {
    ...mapState('store', [
      'Authorization'
    ]),
    title () {
      return this.$route.query.title
    }
  },
  created () {
    this.getRecColumn()
    this.getReadColumn()
    this.getVideoColumn()
  },
  methods: {

    /**
     *跳转直冲分类
    */
    jumpExclusiveColumn (configer) {
      api.configJumpDetails(configer)
    },

    /**
     * 娱乐直冲商品列表
    */
    async getRecColumn () {
      const data = await api.getLocationCodingHandler('fling-center-1')
      if (data) {
        this.recColumnList = data
        // const res = await api.getProductList({ id: data[0].configer.column, pageNum: 1 })
        // if (res.status === 200) {
        //   const { code, data } = res.data
        //   if (code === 0) {
        //     this.recColumnList = data
        //   }
        // }
      }
    },

    /**
     * 阅读
     */
    async getReadColumn () {
      const data = await api.getLocationCodingHandler('fling-center-2')
      if (data) {
        this.readColumnList = data
        // const res = await api.getProductList({ id: data[0].configer.column, pageNum: 1 })
        // if (res.status === 200) {
        //   const { code, data } = res.data
        //   if (code === 0) {
        //     this.readColumnList = data
        //   }
        // }
      }
    },

    /**
     * 视频
    */
    async getVideoColumn () {
      const data = await api.getLocationCodingHandler('fling-center-3')
      if (data) {
        this.videoColumnList = data
        // const res = await api.getProductList({ id: data[0].configer.column, pageNum: 1 })
        // if (res.status === 200) {
        //   const { code, data } = res.data
        //   if (code === 0) {
        //     this.videoColumnList = data
        //   }
        // }
      }
    },

    /**
     * 随机获取热门充值列表
    */
    async getHotRechargeList (id) {
      const res = await api.getProductList({ id })
      if (res) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.hotRechargeList = data
        } else if (code === 9006) {
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.fling-center {
  .hot-column {
    padding: 0.24rem 0.2rem;
    background-color: #fff;
    margin-bottom: 0.2rem;
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 0.46rem;
      color: @base;
      height: 0.34rem;
      font-size: @fz32;
      font-weight: 700;
      padding-left: 0.2rem;
      border-left: 0.055rem solid #fa7676;
    }
    .hot-column-list {
      padding: 0 0.1rem;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .hot-column-sku {
        .flex-column-center;
        margin-bottom: 0.33rem;
        &:nth-child(3n-1) {
          margin: 0 0.33rem 0.33rem;
        }
        .sku-img {
          width: 2.08rem;
          height: 1rem;
        }
        .sku-name {
          width: 2.08rem;
          .ellipsis;
          padding-top: 0.32rem;
          font-size: @fz24;
          color: @base;
        }
      }
    }
  }
}
</style>
